import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X } from "lucide-react";

export default function RestockHistoryDrawer({ product, onClose }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!product) return;
    api.get(`/products/${product.product_id}/restock-log`)
      .then(({ data }) => setItems(data))
      .catch(() => setItems([]));
  }, [product]);
  if (!product) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/50" onClick={onClose} data-testid="restock-drawer-backdrop">
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-[#EDE5D2] brut-border overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="sticky top-0 bg-[#1F3D2A] text-white p-4 flex items-center justify-between">
          <div>
            <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#C77E3C]">/ Restock history</div>
            <div className="heading font-bold uppercase mt-1 truncate max-w-[280px]">{product.title}</div>
          </div>
          <button data-testid="restock-drawer-close" onClick={onClose} className="brut-border bg-white text-[#1F3D2A] p-2 hover:bg-[#C77E3C] hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <div className="p-4">
          {items === null && <div className="mono text-xs uppercase tracking-[0.25em] text-[#555] py-8 text-center">Loading…</div>}
          {items && items.length === 0 && (
            <div className="brut-border bg-white p-6 text-center">
              <div className="mono text-xs uppercase tracking-[0.25em] text-[#555]">No restocks yet</div>
              <p className="text-sm text-[#555] mt-2">Restock events on this product will show up here.</p>
            </div>
          )}
          {items && items.length > 0 && (
            <ol className="space-y-3">
              {items.map((r) => (
                <li key={r.log_id} data-testid={`restock-entry-${r.log_id}`} className="brut-border bg-white p-3">
                  <div className="flex items-baseline justify-between gap-3">
                    <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#555]">{new Date(r.at).toLocaleString()}</div>
                    <div className="brut-border bg-[#C77E3C] text-white px-2 py-0.5 mono text-[10px] uppercase tracking-[0.2em]">+{r.total_added}</div>
                  </div>
                  <div className="mt-2 text-sm">
                    <strong>{r.actor_email}</strong> <span className="mono text-[10px] uppercase tracking-[0.2em] text-[#555]">({r.actor_role})</span>
                  </div>
                  {r.variants && (
                    <div className="mt-2 flex flex-wrap gap-1">
                      {Object.entries(r.variants).map(([k, v]) => (
                        <span key={k} className="brut-border bg-[#FDF3E9] px-2 py-0.5 mono text-[10px] uppercase tracking-[0.2em]">
                          {k.replace("|", " / ")}: +{v}
                        </span>
                      ))}
                    </div>
                  )}
                </li>
              ))}
            </ol>
          )}
        </div>
      </div>
    </div>
  );
}
